import Vue from 'vue'
import VueRouter from 'vue-router'
import Power from '../views/Power.vue'
import Wallet from '../views/Wallet.vue'

Vue.use(VueRouter)

const isLoggedIn = () => {
  if (sessionStorage.getItem('loggedIn')) {
    return true
  }
  return false
}

const routes = [
  {
    path: '/dashboard',
    name: 'power',
    component: Power,
    beforeEnter(to, from, next) {
      if (isLoggedIn()) {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/wallet',
    name: 'power',
    component: Wallet,
    beforeEnter(to, from, next) {
      if (isLoggedIn()) {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    alias: '/',
    component: () => import('../views/Login.vue')
  },
  {
    path: "*",
    name: 'login',
    component: () => import('../views/404.vue'),
    beforeEnter(to, from, next) {
      if (isLoggedIn()) {
        next()
      } else {
        next({
          name: 'login'
        })
      }
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
